export default __webpack_public_path__ + "static/media/amDotNetv1-2.07a18747.jpg";